// src/routes/VendorRoutes.tsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import VendorLayout from '../pages/Vendor/VendorLayout';
import VendorDashboard from '../pages/Vendor/Dashboard';
import VendorProducts from '../pages/Vendor/Products';
import VendorSettingsPage from '../pages/Vendor/Settings';
import VendorPickupsPage from '../pages/Vendor/Pickups';
import PickupDetailPage from '../pages/Vendor/Pickups/PickupDetailsPage';
import VendorReturns from '../pages/Vendor/Returns';
import VendorReturnDetail from '../pages/Vendor/Returns/ReturnDetail';

const VendorRoutes: React.FC = () => {
    return (
        <Routes>
            <Route element={<VendorLayout />}>
                <Route path="dashboard" index element={<VendorDashboard />} />
                <Route path="products">
                    <Route index element={<VendorProducts />} />
                    <Route path="new" element={<div>New Product (Coming Soon)</div>} />
                    <Route path=":id" element={<div>Product Detail (Coming Soon)</div>} />
                    <Route path=":id/edit" element={<div>Edit Product (Coming Soon)</div>} />
                </Route>
                <Route path="pickups">
                    <Route index element={<VendorPickupsPage />} />
                    <Route path=":id" element={<PickupDetailPage />} />
                </Route>
                <Route path="orders" element={<div>Orders (Coming Soon)</div>} />
                <Route path="analytics" element={<div>Analytics (Coming Soon)</div>} />
                <Route path="payouts" element={<div>Payouts (Coming Soon)</div>} />
                <Route path="settings" element={<VendorSettingsPage />} />
                <Route path="returns">
                    <Route index element={<VendorReturns />} />
                    <Route path=":id" element={<VendorReturnDetail />} />
                </Route>
            </Route>
        </Routes>
    );
};

export default VendorRoutes;